export function SupplierPortalLayout({
  children,
  organizationName,
}: {
  children: React.ReactNode
  organizationName?: string
}) {
  const trimmedName = organizationName?.trim()
  const initial = trimmedName ? (Array.from(trimmedName)[0]?.toUpperCase() ?? '?') : '?'

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--supplier-bg)' }}
    >
      <header
        className="flex items-center px-4 py-3 border-b bg-white"
        style={{ borderColor: 'var(--supplier-border)' }}
      >
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
            style={{ backgroundColor: 'var(--supplier-primary-strong)' }}
          >
            {initial}
          </div>
          <div className="flex flex-col min-w-0">
            <span className="text-xs text-muted-foreground">Portail Fournisseur</span>
            {trimmedName && (
              <span
                className="text-sm font-semibold truncate"
                style={{ color: 'var(--supplier-text)' }}
              >
                {trimmedName}
              </span>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1 w-full max-w-[680px] mx-auto px-4 py-6 flex flex-col justify-center">
        {children}
      </main>

      <footer
        className="px-4 py-3 text-center text-xs"
        style={{ color: 'var(--supplier-trust-text)', backgroundColor: 'var(--supplier-trust-bg)' }}
      >
        <span aria-hidden="true">🔒</span> Vos données sont protégées et utilisées uniquement dans le cadre de cette campagne.
      </footer>
    </div>
  )
}
